import * as React from 'react';
import { GroupServiceGetResponse, RateReliefCalculatorServiceResponse } from '../../services/api';
import Tier2Request from './modals/Tier2Request';
import RerateRequest from './modals/RerateRequest';
import { asPercentageValue } from '../../utils/parse';

export default function ReliefSummary({ group, rates, appliedRR, onActionRerate, onActionTier2 }: { group: GroupServiceGetResponse, rates: RateReliefCalculatorServiceResponse, appliedRR: number, onActionRerate: () => void, onActionTier2: () => void }) {  
  const availableRelief = React.useMemo(() => {
    if (rates.rateReliefAvailable && rates.rateReliefAvailable > 1) return 0;
    
    return (rates.rateReliefAvailable! * 100) - appliedRR;
  }, [appliedRR, rates.rateReliefAvailable])

  return (
    <div className="p-4 border-4 rounded-lg border-grey-4">
      <div className="grid grid-cols-[1fr_auto] items-center">
        <div className="flex items-center justify-center px-2 py-3 text-center rounded bg-grey-2">
          <div className="flex flex-col items-center justify-center flex-1 gap-1">
            <div className="text-3xl font-bold text-allstate-blue">{asPercentageValue((rates.rateReliefAvailable > 1 ? 0 : rates.rateReliefAvailable) * 100)}</div>
            <div className="text-2xs">Max relief<br />available</div>
          </div>
          <div className="flex flex-col items-center justify-center flex-1 gap-1 border-l">
            <div className="text-3xl font-bold text-allstate-blue">{asPercentageValue(availableRelief)}</div>
            <div className="text-2xs">Relief still<br />available</div>
          </div>
        </div>

        <div className="flex flex-col gap-2 ml-2">
          <Tier2Request group={group} onActionTier2={onActionTier2} />
          <RerateRequest group={group} onActionRerate={onActionRerate} />
        </div>        
      </div>
    </div>
  )
}